<template>
  <div>
    <div class="main-view" v-loading.body="loading">
      <el-card class="searchCard" shadow="never">
        <!-- 筛选 -->
        <el-col>
          <el-form :inline="true" class="inline-form">
            <el-form-item label="品牌ID：">
              <el-input class="search-input" v-model="form.brandId" auto-complete="off" placeholder="请输入品牌ID"></el-input>
            </el-form-item>
             <el-form-item label="品牌名称：">
              <el-input class="search-input" v-model="form.brandName" auto-complete="off" placeholder="请输入品牌ID"></el-input>
            </el-form-item>
            <el-form-item label="创建时间：">
              <el-date-picker
                v-model="form.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="门店名称：">
              <el-input class="search-input" v-model="form.shopName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="门店编号：">
              <el-input class="search-input" v-model="form.shopId" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item label="区域：">
              <el-select v-model="form.zoneId" placeholder="请选择" class="search-input">
                 <el-option
                  key="item.zoneId"
                  label="全部"
                  value="">
                </el-option>
                <el-option
                  v-for="item in zoneList"
                  :key="item.zoneId"
                  :label="item.zoneName"
                  :value="item.zoneId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="门店类型：">
              <el-select v-model="form.shopType" placeholder="请选择" class="search-input">
                <el-option
                  v-for="item in shopTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <auth-button opt="search" icon="el-icon-search" @click.native="searchList" label="查询" :loading="loadingTable"></auth-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-card>
      <el-card class="tableCard" shadow="never">
        <!-- 代金券统计table -->
        <el-table
          stripe
          style="width:100%;"
          :data="shopList"
          :header-cell-style="{background:'#FAFAFA'}">
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + 1"
            align="center"
            width="60">
          </el-table-column>
          <el-table-column
            prop="shopName"
            label="门店名称"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="shopId"
            label="门店编号"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            min-width="200">
          </el-table-column>
          <el-table-column
            prop="brandName"
            label="所属品牌"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="zoneName"
            label="区域"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="shopType"
            label="门店类型"
            align="center"
            min-width="120">
            <template slot-scope="scope">
              <span>{{SHOP_TYPE[scope.row.shopType]}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="partnerName"
            label="合伙人（加盟商）"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="merchantId"
            label="收款编号（关联支付账号）"
            align="center"
            min-width="120">
          </el-table-column>
          <el-table-column
            prop="fCouponStatus"
            label="操作"
            align="center"
            min-width="120">
            <template slot-scope="scope">
              <auth-button opt="edit" type="text" @click.native="handleClick(scope.row)" label="编辑" :loading="loadingTable"></auth-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-col :span="24" class="btm-action">
        <el-pagination
          v-if="paginations.count > 0"
          class="pagination"
          :page-size="paginations.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="paginations.count"
          :current-page="paginations.pageNo"
          @current-change="onChangeCurrentPage">
        </el-pagination>
      </el-col>
    </div>
  </div>
</template>

<script>
import { getShopList, getZoneInfo } from '@/api/merchant-info'
import { filterToArrayList, SHOP_TYPE } from './ENUM'
import dayjs from 'dayjs'
export default {
  name: 'MerchantWxVoucher',
  components: {
  },
  data () {
    return {
      SHOP_TYPE,
      shopTypeList: filterToArrayList(SHOP_TYPE),
      zoneList: [],
      form: {
        zoneId: '',
        shopType: '',
        shopId: '',
        brandId: '',
        shopName: '',
        brandName: '',
        createTime: null,
        endTime: null,
        time: ''
      },
      paginations: {
        count: 0,
        pageNo: 1,
        pageSize: 10
      },
      shopList: [],
      value: '',
      rowInfo: {}
    }
  },
  watch: {
    'form.time': {
      handler (val) {
        if (val) {
          this.form.createTime = dayjs(this.form.time[0]).format('YYYY-MM-DD HH:mm:ss')
          this.form.endTime = dayjs(this.form.time[1]).format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.form.createTime = null
          this.form.endTime = null
        }
      },
      deep: true
    }

  },
  created () {
    if (this.$route.query.brandId) {
      this.form.brandId = this.$route.query.brandId
    }
    this.getShopList()
    this.getZoneInfo()
  },
  methods: {
    searchList () {
      this.paginations.pageNo = 1
      this.getShopList()
    },
    handleClick (row) {
      this.rowInfo = row
      this.$router.push({ path: '/ShopList/ShopManagement/edit-shop', query: { shopId: row.shopId } })
    },
    onChangeCurrentPage (pageNo) {
      this.paginations.pageNo = pageNo
      this.getShopList()
    },
    // 获取店铺列表
    async getShopList () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const res = await getShopList({ ...this.form, ...this.paginations })
        if (res.error_code === '0') {
          this.shopList = res.data.list
          this.paginations.count = res.data.total
        } else {
          this.$message.error(res.error_msg)
        }
      } catch (e) {
        console.log(e)
      } finally {
        loading.close()
      }
    },
    // 获取地区位置列表
    async getZoneInfo () {
      try {
        const res = await getZoneInfo()
        this.zoneList = res.data
      } catch (e) {
        console.log(e)
      }
    }
  }

}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  padding:20px 0;
  text-align: right;
}
</style>
